module.exports = __webpack_public_path__ + "static/media/LPSecondRowSecondImg.62a5748d.png";